var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { OutsourceLawsuitService } from "~/services/domain-service/outsource-lawsuit-manage-index.service";
import { PageService } from "~/utils/page.service";
import AddCost from "~/components/outsource-manage/outsource-lawsuit-manage/lawsuit-list/add-cost.vue";
import { FileUploadService } from "~/services/file-service/file-upload.service";
import { Prop } from "vue-property-decorator";
var CostMaintain = /** @class */ (function (_super) {
    __extends(CostMaintain, _super);
    function CostMaintain() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowCostData = null;
        _this.model = {
            costEvent: "",
            costType: "",
        };
        _this.dialog = {
            isOpenAddCost: false,
            isOpenFile: false,
        };
        _this.dataSet = [];
        _this.fileDataSet = [];
        return _this;
    }
    CostMaintain.prototype.refreshCostData = function () {
        var _this = this;
        this.outsourceLawsuitService.getCostRecord(__assign(__assign({}, this.model), { assistId: this.rowData.id }), this.pageService).subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    /**
     * 删除
     */
    CostMaintain.prototype.deleteCost = function (row) {
        var _this = this;
        this.outsourceLawsuitService.deleteCostRecord({ id: row.id }).subscribe(function (data) {
            _this.$message.success("删除成功!");
            _this.refreshCostData();
        });
    };
    /**
     * 下载文件
     */
    CostMaintain.prototype.download = function (url, filename) {
        if (filename === void 0) { filename = ''; }
        this.$common.downloadFile(url, filename);
    };
    CostMaintain.prototype.refreshFileData = function () {
        var _this = this;
        this.fileDataSet = [];
        var fileIds = this.rowCostData.fileIds;
        if (!fileIds)
            return;
        this.fileUploadService.getAllUploadFileByIds(fileIds).subscribe(function (data) {
            if (!data || data.length === 0)
                return;
            _this.fileDataSet = data.map(function (v) {
                return { filename: v.originalName, id: v.id, url: v.url };
            });
        });
    };
    __decorate([
        Dependencies(OutsourceLawsuitService)
    ], CostMaintain.prototype, "outsourceLawsuitService", void 0);
    __decorate([
        Dependencies(FileUploadService)
    ], CostMaintain.prototype, "fileUploadService", void 0);
    __decorate([
        Dependencies(PageService)
    ], CostMaintain.prototype, "pageService", void 0);
    __decorate([
        Prop()
    ], CostMaintain.prototype, "rowData", void 0);
    CostMaintain = __decorate([
        Component({
            components: {
                AddCost: AddCost
            }
        })
    ], CostMaintain);
    return CostMaintain;
}(Vue));
export default CostMaintain;
